import { Card, CardHeader, CardTitle, CardDescription } from "./ui/card";
import {
  Shield,
  Bot,
  Globe,
  FileEdit,
  Database,
  Package,
  Home,
  Smartphone,
  Activity,
  GitBranch,
  Server,
  Search,
} from "lucide-react";

const features = [
  {
    icon: Shield,
    title: "Secure",
    description: "Everything runs in a sandboxed Docker environment.",
  },
  {
    icon: Bot,
    title: "Autonomous",
    description: "Automatically detects the next step and performs it.",
  },
  {
    icon: Globe,
    title: "Browser Integration",
    description: "Fetches latest information from the web if needed.",
  },
  {
    icon: FileEdit,
    title: "Built-in Text Editor",
    description: "View all modified files right in your browser.",
  },
  {
    icon: Database,
    title: "History Tracking",
    description: "All commands and outputs are saved in PostgreSQL.",
  },
  {
    icon: Package,
    title: "Automatic Docker-image Picker",
    description: "Selects the right image based on the user task.",
  },
  {
    icon: Home,
    title: "Self-hosted",
    description: "Run PentAGI on your own infrastructure.",
  },
  {
    icon: Smartphone,
    title: "Modern UI",
    description: "Sleek and intuitive user interface.",
  },
  {
    icon: Activity,
    title: "Langfuse Integration",
    description: "Control and monitor AI-agents while they work.",
  },
  {
    icon: GitBranch,
    title: "Version Control",
    description: "View current tool state in the GitHub project.",
  },
  {
    icon: Server,
    title: "Customizable API",
    description: "Fully customized system outside via REST API and GraphQL.",
  },
  {
    icon: Search,
    title: "Internet Search",
    description:
      "Looks for information via search engines like Google, Tavily, and Traversaal.",
  },
];

export default function Features() {
  return (
    <section id="features" className="py-20 bg-muted/50">
      <div className="container mx-auto">
        <h2 className="text-3xl font-bold mb-12 text-center">Features</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <Card key={index}>
              <CardHeader>
                <feature.icon className="w-10 h-10 mb-3 text-primary" />
                <CardTitle>{feature.title}</CardTitle>
                <CardDescription>{feature.description}</CardDescription>
              </CardHeader>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
